import { useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

interface SettingsItem {
  title: string;
  description: string;
  icon: React.ElementType;
  path: string;
}

const settingsItems: SettingsItem[] = [
  {
    title: 'Reference contact questions',
    description: 'Configure system-wide questions for all reference contacts',
    icon: MessageSquare,
    path: '/settings/referee-questions',
  },
];

export function SettingsPage(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className="container py-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Settings</h1>
        <p className="text-muted-foreground">System configuration and preferences</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {settingsItems.map((item) => (
          <Card
            key={item.path}
            className="cursor-pointer hover:bg-muted/50 transition-colors"
            onClick={() => navigate(item.path)}
          >
            <CardHeader>
              <item.icon className="h-8 w-8 text-primary mb-2" />
              <CardTitle>{item.title}</CardTitle>
              <CardDescription>{item.description}</CardDescription>
            </CardHeader>
          </Card>
        ))}
      </div>
    </div>
  );
}
